module.exports = __webpack_public_path__ + "static/img/thongbao.a0813b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thongbao.jpg
// module id = Mqky
// module chunks = 1